/* eslint-disable react-hooks/exhaustive-deps */

import clsx from 'clsx'
import {useState, useEffect} from 'react'
// import { useNavigate } from 'react-router-dom'
import { getCart } from '../../../../redux/action/card'
import { useSelector, useDispatch } from 'react-redux'
import CartTray from './CartTray'
import AccountSwitcher from '../../../partials/layout/header-menus/AccountSwitcher'

const itemClass = 'ms-1 ms-md-4'
// const userAvatarClass = 'symbol-35px'

const Navbar = (props) => {
  const [isTrayOpen, setTrayOpen] = useState(false)
  const dispatch = useDispatch()
  // const navigate = useNavigate()
  const openTray = () => {
    setTrayOpen(true)
    window.dispatchEvent(new CustomEvent('updateCartOpen', { detail: { newState: true } }))
  }
  const closeTray = () => {
    setTrayOpen(false)
    window.dispatchEvent(new CustomEvent('updateCartOpen', { detail: { newState: false } }))
  }

  // We assume the cart items are stored here:
  const cartItems = useSelector((state: any) => state.Card?.UserCart) || []
  const [totalQuantity, setTotalQuantity] = useState(0)
  const [totalPrice, setTotalPrice] = useState(0)
  useEffect(() => {
    dispatch(getCart())
    window.addEventListener('openCartTray', () => {
      setTrayOpen(true)
    })
  }, [dispatch])

  useEffect(() => {
    dispatch(getCart())
  }, [isTrayOpen])

  useEffect(() => {
    setTotalQuantity(cartItems.length)
    setTotalPrice(cartItems.reduce((sum, item) => sum + (item.price * item.quantity || 0), 0))
  }, [cartItems])

  // Decide if we want to show the cart icon or not
  // If you'd like to *always* show it, remove the `&& cartItems.length > 0`
  return (
    <div className='app-navbar d-flex align-items-center gap-4 m-3'>

      {/* Account Switcher for B2B account switching */}
      <div className={clsx('app-navbar-item', itemClass)}>
        <AccountSwitcher />
      </div>

      {/* Other nav items here... */}

      {/* Only show cart icon if there's at least 1 item.
          If you want to show it ALWAYS, remove the "cartItems.length > 0" check. */}
      {
      //cartItems.length > 0 && (
        <div className={clsx('app-navbar-item d-flex align-items-center', itemClass)}>
          {/* Show total price on the left */}
          {totalPrice > 0 && (
          <div className='text-dark fw-bold'>
            ${totalPrice.toFixed(2)}
          </div>
          )}

          {/* Wrap cart icon in a clickable container, with position: relative for the badge */}
          <div
            className='position-relative'
            style={{cursor: 'pointer'}}
            onClick={openTray}
          >
            <i className='fas fa-cart-shopping ms-2 fs-3x'></i>

            {/* Red badge with total quantity.
                "position-absolute top-0 start-100 translate-middle"
                places it at top-right corner. */}
            {totalQuantity > 0 && (
              <span style={{color:'white'}} className='position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger'>
                {totalQuantity}
              </span>
            )}
          </div>
        </div>

      //)
      }
  <CartTray isOpen={isTrayOpen} onClose={closeTray} />
    </div>
  )
}

export { Navbar }